import React, { Component, createRef, useMemo } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
// import ReCAPTCHA from "react-google-recaptcha";
import { Form, Input, Row, Typography } from "antd";
const { Title } = Typography;
// const API_KEY = process.env.REACT_APP_SITE_KEY;
// const recaptchaRef = React.createRef();
const labelStyle = { fontWeight: "600", fontSize: "14px" };
class AgentFormPage extends React.Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { finalForm } = this.props.finalForm;
    const {booking_customer_form} = this.props
    return (
      <div style={{paddingTop:"2rem"}}>
        <Row>
          <Title level={4}>Selected Agent</Title>
          <div
            style={{
              padding: "10px",
              backgroundColor: "#ececec",
              marginBottom: "2rem",
            }}
          >
            <div style={{ paddingBottom: "1rem" }}>
              <span style={{ fontWeight: "600" }}>Company Name :</span>&nbsp;
              {this.props?.selectedAgent?.company_name}
            </div>
            <div style={{ paddingBottom: "1rem" }}>
              <span style={{ fontWeight: "600" }}>Contact Name: </span>&nbsp;
              {this.props?.selectedAgent?.contact_name}
            </div>
            <div style={{ paddingBottom: "1rem" }}>
            
              <span style={{ fontWeight: "600" }}>Email : </span>&nbsp;
              {this.props?.selectedAgent?.email}
            </div>
          </div>
        </Row>
        <Row>
        {booking_customer_form?.customer_type === "Importer" ? 
          <Title level={4}>Shipper Details</Title> :
          <Title level={4}>Receiver Details</Title> }
          <div
            style={{
              padding: "10px",
              backgroundColor: "#ececec",
              marginBottom: "2rem",
            }}
          >
            <div style={{ paddingBottom: "1rem" }}>
              <span style={{ fontWeight: "600" }}>Company Name:</span>&nbsp;
              {this.props?.shipperInfo?.company_name}
            </div>
            <div style={{ paddingBottom: "1rem" }}>
              <span style={{ fontWeight: "600" }}>Contact Name: </span>&nbsp;
              {this.props?.shipperInfo?.customer_first_name}&nbsp;
              {this.props?.shipperInfo?.customer_last_name}
            </div>
            <div style={{ paddingBottom: "1rem" }}>
              {" "}
              <span style={{ fontWeight: "600" }}>Email : </span>&nbsp;
              {this.props?.shipperInfo?.email}
            </div>
          </div>
        </Row>
        <Row>
          <Form.Item
            label={<span style={labelStyle}>Message</span>}
            colon={false}
          >
            {getFieldDecorator("message", {
              //initialValue: this.state?.message,
              initialValue: finalForm?.message,
              rules: [
                { required: false, message: "Please input your message!" },
              ],
            })(
              <Input.TextArea rows={5} placeholder="Enter your message here" />
            )}
          </Form.Item>
        </Row>
        {/* <Row>
          <Form.Item
            label={<span style={labelStyle}>CAPTCHA</span>}
            colon={false}
          >
            {getFieldDecorator("captcha", {
              rules: [{ required: true, message: "required" }],
            })(
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={API_KEY}
                onChange={this.handleChange}
              />
            )}
          </Form.Item>
        </Row> */}
      </div>
    );
  }
}
const WrappedAgentFormPage = Form.create({ name: "agentForm" })(AgentFormPage);
AgentFormPage.propTypes = {
  /** * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories. * It also accepts `null` */
  queryParams: PropTypes.object,
  booking_customer_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    booking_customer_form: state.route.booking_customer_form,
  };
};
export default withRouter(
  connect(mapStateToProps, actions)(WrappedAgentFormPage)
);
